import {
	FormattedText,
	getPropertySortText,
	OptionsMenu,
	OptionsMenuItem,
	SearchInputForm,
	Typography
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import styles from "./SearchAndSort.module.less";
import { HubHierarchySortKind } from "client/Api/Hub/hubSidebarManagement";

export type HubSidebarManagementSortMode = {
	kind: "disabled";
} | {
	kind: "enabled";
	sortKind: HubHierarchySortKind;
	onSortKindChange(kind: HubHierarchySortKind): void;
};

export type SearchAndSortProps = {
	searchTerm: VersionedValue<string>;
	sortMode: HubSidebarManagementSortMode;
	onSearch: (term: VersionedValue<string>) => void;
};

export const SearchAndSort = (props: SearchAndSortProps): ReactElement => {
	const {
		searchTerm,
		onSearch,
		sortMode
	} = props;

	return (
		<div className={styles.searchAndSort}>
			<SearchInputForm
				value={searchTerm}
				onChange={(value, version) => onSearch({ value, version })}
				height="large"
				icon="filter"
				placeholder={(
					<FormattedText
						text={localize("_FilterByProperties")}
						thingsToReplace={[
							{
								what: "{{Properties}}",
								filler: (
									<Typography weight="bold" isItalic>
										{localize("_GroupsAndCategories")}
									</Typography>
								)
							}
						]}
					/>
				)}
				trackingId="search"
			/>
			{sortMode.kind === "enabled" && (
				<OptionsMenu
					options={sortOptions}
					value={sortMode.sortKind}
					title={localize("_SortBy")}
					onChange={sortMode.onSortKindChange}
					buttonSize="large"
					icon="arrow-up-arrow-down"
					trackingId="sort-kind-drop-over"
				/>
			)}
		</div>
	);
};
SearchAndSort.displayName = "SearchAndSort";

export const sortKindToNameMap: Record<HubHierarchySortKind, string> = {
	[HubHierarchySortKind.Default]: getPropertySortText("_Default", "_AToZ"),
	[HubHierarchySortKind.Custom]: localize("_CustomSorting")
};

const sortOptions: readonly OptionsMenuItem<HubHierarchySortKind>[] = [
	{
		text: sortKindToNameMap[HubHierarchySortKind.Default],
		value: HubHierarchySortKind.Default
	},
	{
		text: sortKindToNameMap[HubHierarchySortKind.Custom],
		value: HubHierarchySortKind.Custom
	}
];
